<template>
    <div class="darkBG newsBG" :style="{background:'url('+newsBg2+')'}" v-loading="loading">
      <div class="title">
        新闻中心
      </div>
      <div class="title">
        NEWS INFORMATION
      </div>
      <div class="newsPage contentBox mainContent">
          <div class="newsPageTitle">
            <div id="type1" class="newsPageTitleText active" @click="getNewsData(1)">
              公司新闻
            </div>
            <div id="type2" class="newsPageTitleText" @click="getNewsData(2)">
              行业资讯
            </div>
          </div>
          <div class="newsPageBG"></div>  
          <Newslist :newsList="newsDataList" @itemClick="linkTo"/>     
          <div class="pageButton">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-count="totalPage"
              @current-change="changePage"
              >
            </el-pagination>
          </div>       
      </div>

      <div class="mob">
        <div class="title">
          <div class="zh">新闻中心</div>
          <div class="en">NEWS INFORMATION</div>
        </div>
        <div class="newsListBox">
          <Newslist :newsList="newsDataList" @itemClick="linkTo"/>  
        </div>
        <div class="pageButton">
          <el-pagination
            background
            layout="prev, pager, next"
            :small="true"
            :page-count="totalPage"
            @current-change="changePage"
            >
          </el-pagination>
        </div>
      </div>
    </div>
</template>

<script>
import Newslist from '@/components/NewsList.vue'
//静态资源导入
import newsBg2 from '@/assets/img/newsBg2.jpg'

export default {
  name: 'newsPage',
  props: {
    contentType:{
      type: Number,
      default: 1
    }
  },
  components: {
    Newslist
  },
  watch:{    
    'contentType': function(){
      this.getNewsData(this.contentType,1);
    }
  },
  data() {
    return {
      //静态资源导入S
      newsBg2:newsBg2,
      //静态资源导入E
      baseUrl:window.config.apiUrl,
      newsDataList:[],
      totalPage:1,
      type:1,
      loading:false,
    }
  },
  methods: {
    async getBaseData(type = 1,page = 1) {
      try {
        let info = await this.$root.getNewsList(type,3,page);
        this.newsDataList = [];
        this.totalPage = info.data.last_page;
        this.newsDataList = info.data.data;      
        this.$root.loadingClose();  
      } catch (error) {
        this.error = '获取数据失败：' + error.message;
      }
    },
    async getNewsData(type = 1,page = 1) {
      this.loading = true;
      let allType = document.querySelectorAll('.newsPageTitleText');
      allType.forEach(element => {
        element.classList.remove('active');
      });

      this.type = type;

      let target = document.getElementById('type'+type);
      if(target){
        this.$nextTick(function(){
          target.classList.add('active');
        })
      }      
      await this.getBaseData(type,page);
      this.fixHeight();
      //处理日期
      this.newsDataList.forEach(element => {
        let timestamp = element.updatetime;
        //转换时间戳为YYYY-MM-DD格式
        let date = new Date(timestamp*1000).toLocaleDateString();
        let dateArr = date.split("/");
        element.year = dateArr[0];
        element.mounth = dateArr[1];
        element.day = dateArr[2];
      });
      this.loading = false;
    },
    changePage(page){
      this.getNewsData(this.type,page);
    },
    fixHeight(){
        //修复背景高度
        let newsPageBG = document.getElementsByClassName('newsPageBG')[0];
        let newsPage = document.getElementsByClassName('newsPage')[0];
        let newsBG = document.getElementsByClassName('newsBG')[0];
        
        if(newsPageBG && newsPage && this.newsDataList.length <= 3){
            newsPageBG.style.height = newsPage.offsetHeight - 200 + 'px';
            newsBG.style.height = newsPage.offsetHeight + 200 + 'px';
        }
        else{
          newsPageBG.style.height = '1200px';
          newsBG.style.height = '1500px';
        }

        if(this.$root.isMob){
          let num = this.newsDataList.length;
          newsPageBG.style.height = (num * 140 + 200) + 'px';
          newsBG.style.height = (num * 140 + 200) + 'px';
        }
    },
    linkTo(id){
      window.open("/#/newsDetail?id="+id,"_blank");
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.getNewsData();
    });    
  },
  destroyed() {
    this.$root.changeContentType(1);
  }
}
</script>

<style lang="scss" src="@/assets/css/newsPage.scss" scoped></style>